// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__MBoNy","icon":"menu_icon__rbq6B","tag":"menu_tag__8T5_D","active":"menu_active__5d45y","inactive":"menu_inactive__v2pxQ"};